import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { Proteins } from 'models/Pet'
import { FrozenRecipeDetail } from 'features/Recipes/FrozenRecipeDetail'

export default function RecipePage() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: 'Turkey Recipe',
    image: [
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fturkey-bowl.fa372720.webp&w=3840&q=75',
      'https://wefeedraw.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Ffrozen-turkey-pouch-white-wrapper.cb8a6935.webp&w=3840&q=75',
    ],
    description:
      "We Feed Raw's Turkey Recipe is a delicious and easily digestible single-protein dog food recipe that supports skin and coat health. Formulated by a PhD nutrition expert to be complete + balanced for dogs of all life stages.",
    brand: {
      '@type': 'Brand',
      name: 'We Feed Raw',
    },
    manufacturer: {
      '@type': 'Organization',
      name: 'We Feed Raw',
    },
    url: 'https://wefeedraw.com/recipes/turkey',
    additionalProperty: [
      {
        '@type': 'PropertyValue',
        name: 'Protein',
        value: 'Turkey',
      },
      {
        '@type': 'PropertyValue',
        name: 'Turkey Quality',
        value: 'Made with Cage-Free Turkey',
      },
      {
        '@type': 'PropertyValue',
        name: 'Antibiotics',
        value: 'Minimally Processed',
      },
      {
        '@type': 'PropertyValue',
        name: 'Harvesting Method',
        value: 'Humanely Harvested',
      },
    ],
    offers: {
      '@type': 'Offer',
      price: '9.66',
      priceCurrency: 'USD',
      availability: 'https://schema.org/InStock',
      itemCondition: 'https://schema.org/NewCondition',
      seller: {
        '@type': 'Organization',
        name: 'We Feed Raw',
      },
      url: 'https://wefeedraw.com/recipes/turkey',
      shippingDetails: {
        '@type': 'OfferShippingDetails',
        shippingRate: {
          '@type': 'MonetaryAmount',
          value: '0.00',
          currency: 'USD',
        },
        shippingDestination: {
          '@type': 'DefinedRegion',
          addressCountry: 'US',
        },
      },
      priceSpecification: [
        {
          '@type': 'UnitPriceSpecification',
          price: '16.10',
          priceCurrency: 'USD',
          priceType: 'ListPrice',
        },
        {
          '@type': 'UnitPriceSpecification',
          price: '9.66',
          priceCurrency: 'USD',
          priceType: 'SalePrice',
        },
      ],
    },
    isSimilarTo: [
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/beef',
      },
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/chicken',
      },
      {
        '@type': 'Product',
        name: 'Duck Recipe',
        url: 'https://wefeedraw.com/recipes/duck',
      },
      {
        '@type': 'Product',
        name: 'Lamb Recipe',
        url: 'https://wefeedraw.com/recipes/lamb',
      },
      {
        '@type': 'Product',
        name: 'Chicken Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-chicken',
      },
      {
        '@type': 'Product',
        name: 'Beef Recipe',
        url: 'https://wefeedraw.com/recipes/freeze-dried-raw-beef',
      },
    ],
  }

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('recipes:TURKEY.page-title')}</title>
        <meta name="title" content={t('recipes:TURKEY.meta-title')} />
        <meta name="description" content={t('recipes:TURKEY.meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/recipes/turkey" />
        <script
          id="schema-script"
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: jsonLdString }}
        />
      </Head>

      <main>
        <FrozenRecipeDetail protein={Proteins.TURKEY} />
      </main>
    </div>
  )
}
